import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { SalesButton } from '../ui/SalesButton';
export function PricingBundles() {
  const bundles = [{
    name: 'Starter Trial',
    bottles: '1 Bottle',
    desc: 'Perfect to test it for yourself.',
    price: 49,
    image: 'https://cdn.magicpatterns.com/uploads/doTq5UY2sKAViVPh6SZn2H/LymphoriaX_(28).png',
    features: ['Daily Drop Ritual', 'FREE Flat Morning Guide ($39 Value)', 'Free Worldwide Shipping', '90-Day Guarantee'],
    popular: false,
    cta: 'Order Starter Trial'
  }, {
    name: 'Most Popular — 3 Bottle Full Reset',
    bottles: '3 Bottles',
    desc: 'Best for visible depuff + comfort.',
    price: 99,
    save: 'Save 40%',
    image: 'https://cdn.magicpatterns.com/uploads/pAe7GZgUEk5voqazkBCz1Z/LymphoriaX_(27).png',
    features: ['Full Reset Support', 'All Bonuses Included', 'Priority Processing', 'Free Worldwide Shipping', '90-Day Guarantee'],
    popular: true,
    cta: 'Start Full Reset'
  }, {
    name: 'Best Value — 6 Bottle Never Go Back Bundle',
    bottles: '6 Bottles',
    desc: 'For long-term maintenance + biggest savings.',
    price: 149,
    save: 'Save 55%',
    image: 'https://cdn.magicpatterns.com/uploads/r3rndBrn6LvwhWBgFhbQis/LymphoriaX_(29).png',
    features: ['Best Price Per Bottle', 'Never Run Out', 'Share With Family', 'All Bonuses Included', 'Free Worldwide Shipping'],
    popular: false,
    cta: 'Claim Best Value Bundle'
  }];
  return <section id="pricing" className="py-24 bg-white" data-id="element-195">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-196">
        <div className="text-center mb-16" data-id="element-197">
          <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-198">
            OFFER SECTION
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mt-4 mb-6" data-id="element-199">
            Choose Your Reset Bundle
          </h2>
          <p className="text-xl text-[#374151] max-w-2xl mx-auto" data-id="element-200">
            Most women choose the 3-bottle reset…
            <br data-id="element-201" />
            <span className="font-bold" data-id="element-202">
              Because the biggest regret is stopping too early and going back to
              puffiness.
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start" data-id="element-203">
          {bundles.map((bundle, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`relative rounded-3xl p-8 border-2 ${bundle.popular ? 'border-[#10B981] bg-[#F0FFF4] shadow-xl scale-105 z-10' : 'border-gray-100 bg-white shadow-lg'}`} data-id="element-204">
              {bundle.popular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#10B981] text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-205">
                  MOST POPULAR
                </div>}

              <div className="flex justify-center mb-6" data-id="element-206">
                <img src={bundle.image} alt={`LymphoriaX ${bundle.bottles}`} className="h-48 w-auto object-contain drop-shadow-lg" data-id="element-207" />
              </div>

              <div className="text-center mb-8" data-id="element-208">
                <h3 className="font-bold text-[#1B5E20] text-xl mb-2" data-id="element-209">
                  {bundle.name}
                </h3>
                <p className="text-sm text-gray-500 mb-6" data-id="element-210">{bundle.desc}</p>
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-211">
                  <span className="text-5xl font-bold text-[#1B5E20]" data-id="element-212">
                    ${bundle.price}
                  </span>
                  {bundle.save && <span className="bg-red-100 text-red-600 px-2 py-1 rounded-md text-sm font-bold" data-id="element-213">
                      {bundle.save}
                    </span>}
                </div>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-214">
                {bundle.features.map((feature, idx) => <li key={idx} className="flex items-center gap-3 text-sm text-[#374151]" data-id="element-215">
                    <Check className="w-5 h-5 text-[#10B981] flex-shrink-0" data-id="element-216" />
                    {feature}
                  </li>)}
              </ul>

              <SalesButton fullWidth variant={bundle.popular ? 'primary' : 'secondary'} className={!bundle.popular ? 'bg-gray-800 hover:bg-gray-700' : ''} data-id="element-217">
                {bundle.cta}
              </SalesButton>
            </motion.div>)}
        </div>
      </div>
    </section>;
}